import React from 'react';
import { useLocation, useParams, Link } from 'react-router-dom';
import {
  Container,
  AppBar,
  Toolbar,
  Typography,
  Button,
  Box,
  Paper,
} from '@mui/material';
import { Save, Cancel } from '@mui/icons-material';
import AddEditAuthor from './../../AddEditAuthor/AddEditAuthor';

const AuthorsAddEditPage = () => {
  const location = useLocation();
  const { id } = useParams();
  const isEdit = location.pathname.includes('edit');
  const authorRef = React.useRef();

  const handleSave = (e) => {
    e.preventDefault();
    authorRef.current?.submit();
  };

  return (
    <Container sx={{ paddingBottom: 4 }}>
      <AppBar position="static">
        <Toolbar>
          <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
            {isEdit ? "Edit Author" : "Create New Author"}
          </Typography>
          <Button
            color="error"
            component={Link}
            to="/authors"
            startIcon={<Cancel />}
            variant="contained"
            sx={{ marginRight: 2 }}
          >
            Cancel
          </Button>
          <Button
            color="success"
            onClick={handleSave}
            startIcon={<Save />}
            variant="contained"
          >
            {isEdit ? "Update" : "Create"}
          </Button>
        </Toolbar>
      </AppBar>
      <Box gap={4}>
        <Paper sx={{ padding: 2 }}>
          <AddEditAuthor
            ref={authorRef}
            isEdit={isEdit}
            selectedId={id}
          />
        </Paper>
      </Box>
    </Container>
  );
};

export default AuthorsAddEditPage;
